import { CLEAR_ROOM } from "../conference";
import { ReducerRegistry } from "../redux";
import { SET_CAVNAS_PROPERTY } from "./actionTypes";
import { CANVAS_TOOL, RECTANGLE } from "./constants";

const DEFAULT_STATE = {
    tool: CANVAS_TOOL.pen,    
    zoom: 100,
    isWidthFit: undefined,
    textTheme: false,
    thickness: 2,
    opacity: 1,
    color: "black",
    isPartEraser: true,
    figure: RECTANGLE,
    showOption: false,
    record: false
};
const handlerOption = ["thickness", "opacity", "color", "eraser", "figure", "showOption","zoom"];
ReducerRegistry.register("features/base/canvas", (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CLEAR_ROOM:
            return {
                ...state, 
                tool: "pen",    
                zoom: 100,
                isWidthFit: undefined,
                textTheme: false,
                thickness: 2,
                opacity: 1,
                color: "black",
                isPartEraser: true,
                figure: RECTANGLE,
            }

        case SET_CAVNAS_PROPERTY:            
            return {
                ...state, 
                ...action.data
            }
    }

    return state;
});